import Field, { inputClass } from '../../common/Field'
import Affixed, { affixedInputClass } from '../../common/Affixed'
import { PH_DIALLING_CODE, toNational } from '../../../utils/phone'
import { useWizard } from '../../../context/WizardContext'
import { FIELDS, MESSAGES } from '../../../utils/copy'

/**
 * Step 3 — somebody to ring at the shop end, if there is anybody at all.
 *
 * **Most customers should pass straight through this**, which is why Skip is the same size
 * as Continue and the hint says so before the fields do. Nobody is waiting at Jollibee for
 * somebody else's order; the rider buys it and leaves.
 *
 * It exists for the other case. On a padala the thing is being handed over by a person,
 * and on a pabili from a small shop there is often somebody who knows what was set aside.
 * Left blank, the rider gets the customer's own number, which is the right answer when a
 * problem at the counter needs a decision.
 */
export default function PickupContactStep() {
  const { state, errors, setField } = useWizard()

  return (
    <div className="grid gap-4">
      <p className="text-label font-semibold uppercase text-ink-3">{MESSAGES.optional}</p>

      <Field id="pickupContactName" label={FIELDS.contactName}>
        <input
          id="pickupContactName"
          type="text"
          maxLength={80}
          autoComplete="off"
          value={state.pickupContactName}
          onChange={(event) => setField('pickupContactName', event.target.value)}
          className={inputClass(false)}
        />
      </Field>

      <Field id="pickupContactPhone" label={FIELDS.contactPhone} error={errors.pickupContactPhone}>
        <Affixed affix={PH_DIALLING_CODE} invalid={Boolean(errors.pickupContactPhone)} wide>
          <input
            id="pickupContactPhone"
            type="tel"
            inputMode="numeric"
            autoComplete="off"
            placeholder="9171234567"
            value={state.pickupContactPhone}
            onChange={(event) => setField('pickupContactPhone', toNational(event.target.value))}
            aria-invalid={Boolean(errors.pickupContactPhone)}
            aria-describedby={errors.pickupContactPhone ? 'pickupContactPhone-error' : undefined}
            className={affixedInputClass(errors.pickupContactPhone, true)}
          />
        </Affixed>
      </Field>
    </div>
  )
}
